<template>
  <form
    ref="form"
    data-url="/organizations"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <fieldset class="form-group">
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5 v-html="$store.getters.getTag('4.1')"></h5>
        </legend>

        <div class="col-12">
          <div class="row form-group">
            <label class="col-auto">¿Los datos son diferentes del Solicitante que declara en el numeral 1?</label>
            <app-input class="col-auto"
                       type="radio-buttons"
                       v-model="showForm"
                       :list="isActive"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="showForm">
        <div class="col-md-6">
          <div class="form-group">
            <label>Nombre Comercial</label>
            <app-input
              type="text"
              v-model="inputs.name"
              placeholder="Ingrese el Nombre Comercial"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo de Identificación</label>
            <app-input
              type="select"
              v-model="inputs.taxid_type"
              v-on:change="
                onChangeTaxid('orgTaxid', inputs.taxid_type, inputs.taxid)
              "
              :required="true"
              :list="taxidTypeLists"
              :disabled="disabled"
            />
          </div>
        </div>
        <div class="col-md-6" v-if="inputs.taxid_type == 'ruc'">
          <div class="form-group">
            <label>RUC</label>
            <app-input
              type="text"
              v-model="inputs.taxid"
              :disabled="disabled"
              placeholder="Ingrese el RUC"
              :required="true"
              @keyup="
                () => {
                  inputs.taxid = inputs.taxid.replace(/[^0-9]/g, '');
                  onChangeTaxid(
                    'orgTaxid',
                    inputs.taxid_type,
                    inputs.taxid
                  );
                }
              "
            />
          </div>
        </div>
        <div class="col-md-6" v-if="inputs.taxid_type == 'other'">
          <div class="form-group">
            <label>RUT, NIT, Etc.</label>
            <app-input
              type="text"
              v-model="inputs.taxid"
              :disabled="disabled"
              placeholder="Ingrese el RUT, NIT, Etc."
              :required="true"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Razón Social</label>
            <app-input
              type="text"
              placeholder="Ingrese la razon social"
              v-model="inputs.business_name"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Representante Legal</label>
            <app-input
              type="text"
              v-model="inputs.legal_representative"
              placeholder="Ingrese el Representante Legal"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo de Identificación</label>
            <app-input
              type="select"
              v-model="inputs.lr_taxid_type"
              v-on:change="
                onChangeTaxid(
                  'lrTaxid',
                  inputs.lr_taxid_type,
                  inputs.legal_representative_taxid
                )
              "
              :required="true"
              :list="lrTaxidTypeLists"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>C.I.</label>
            <app-input
              type="text"
              v-model="inputs.legal_representative_taxid"
              :disabled="disabled"
              placeholder="Ingrese la C.I."
              :required="true"
              @keyup="
                () => {
                  inputs.legal_representative_taxid =
                    inputs.legal_representative_taxid.replace(/[^0-9]/g, '');
                  onChangeTaxid(
                    'lrTaxid',
                    inputs.lr_taxid_type,
                    inputs.legal_representative_taxid
                  );
                }
              "
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo de Entidad</label>
            <app-input
              type="select"
              v-model="inputs.organization_type"
              :required="true"
              :list="[
                { id: '', value: 'Seleccione una opción' },
                ...organizationTypeList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>País</label>
            <app-input
              type="select"
              v-model="inputs.country_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...this.$store.state.common.countries,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div
          class="col-md-6"
          v-if="inputs.country_id && provinceList.length <= 1"
        >
          <div class="form-group">
            <label>Ciudad</label>
            <app-input
              type="text"
              v-model="inputs.city"
              placeholder="Ingrese la ciudad"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group mb-2 mb-md-0">
            <label>Provincia</label>
            <app-input
              type="select"
              v-model="inputs.province_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...provinceList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group mb-2 mb-md-0">
            <label>Ciudad</label>
            <app-input
              type="select"
              v-model="inputs.canton_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...cantonList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>E-mail</label>
            <app-input
              type="email"
              v-model="inputs.email"
              placeholder="Ingrese su email"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Teléfono</label>
            <app-input
              type="tel-input"
              v-model="inputs.phone"
              placeholder="Ingrese su numero de telefono"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Dirección</label>
            <app-input
              type="textarea"
              v-model="inputs.address"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese la dirección"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Pág. Web</label>
            <app-input
              type="text"
              v-model="inputs.web"
              placeholder="Ingrese su pagina web"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <!-- <div class="col-12">
          <div class="form-group mb-2 mb-md-0">
            <label>Actividad Principal</label>
            <app-input
              type="textarea"
              v-model="inputs.main_activity"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese la actividad principal"
            />
          </div>
        </div> -->

        <div class="col-md-6">
          <div class="form-group">
            <label>UNICÓDIGO</label>
            <app-input
              type="text"
              v-model="inputs.unicode"
              :required="true"
              :disabled="disabled"
              placeholder="Unicódigo"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>TIPOLOGÍA</label>
            <app-input
              type="text"
              v-model="inputs.tipology"
              :required="true"
              :disabled="disabled"
              placeholder="Tipología"
            />
          </div>
        </div>

        <div class="col-12">
          <label>El laboratorio realiza análisis para:</label>
          <div class="form-group">
            <app-input
              type="checkbox"
              :required="true"
              :list="labOptions"
              v-model="inputs.checkboxm"
              :disabled="disabled"
            />
          </div>
        </div>
        

        <div class="col-12 mt-3" v-if="!disabled">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  props: {
    disabled: Boolean,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        checkboxm: [],
      },
      provinceList: [],
      cantonList: [],
      showForm: 0,
      isActive: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      delayTimer: null,
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ruc", value: "Nacional" },
        { id: "other", value: "Internacional" },
      ],
      lrTaxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ci", value: "Cédula de Identidad" },
        { id: "ruc", value: "RUC" },
        { id: "other", value: "Otros" },
      ],
      organizationTypeList: [
        { id: "private", value: "Entidad privada" },
        { id: "public", value: "Entidad pública" },
        { id: "other", value: "Otros" },
      ],
    };
  },
  computed: {
    labOptions() {
      return [
        {
          id: "HCCM",
          value: "Hospitales / Clínicas / Centros Médicos",
        },
        {
          id: "OL",
          value: "Otros Laboratorios",
        },
        {
          id: "P",
          value: "Público",
        },
        {
          id: "I",
          value: "Investigación",
        },
      ];
    },
  },
  created() {
    this.data();
  },
  watch: {
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.inputs.establishment_type = "P";
      this.inputs.fate_laboratory = this.inputs.checkboxm.join("|");
      this.save({ org: this.inputs });
    },

    afterSuccess(response) {
      // this.$toastr.s(res.data.message);
      this.inputs = response.data.org;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `/organizations/parent?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = response.data;
            if (response.data.fate_laboratory) {
              this.inputs.checkboxm = response.data.fate_laboratory.split("|");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    onChangeTaxid(origin, type, taxid) {
      this[origin] = false;
      if (taxid && ["ci", "ruc"].includes(type)) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          if (type == "ruc" && taxid.length != 13) {
            this.$toastr.e("El RUC debe tener 13 digitos");
            return;
          }
          // this.validateTaxid(origin, type, taxid);
        }, 1000);
      } else {
        this[origin] = true;
      }
    },
  },
};
</script>
